var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.431641 1.375C0.431641 0.6875 0.994141 0.125 1.68164 0.125C2.36914 0.125 2.93164 0.6875 2.93164 1.375C2.93164 2.0625 2.36914 2.625 1.68164 2.625C0.994141 2.625 0.431641 2.0625 0.431641 1.375ZM4.18164 2H20.4316V0.75H4.18164V2ZM4.18164 5.75H20.4316V7H4.18164V5.75ZM20.4316 10.75H4.18164V12H20.4316V10.75ZM1.68164 5.125C0.994141 5.125 0.431641 5.6875 0.431641 6.375C0.431641 7.0625 0.994141 7.625 1.68164 7.625C2.36914 7.625 2.93164 7.0625 2.93164 6.375C2.93164 5.6875 2.36914 5.125 1.68164 5.125ZM0.431641 11.375C0.431641 10.6875 0.994141 10.125 1.68164 10.125C2.36914 10.125 2.93164 10.6875 2.93164 11.375C2.93164 12.0625 2.36914 12.625 1.68164 12.625C0.994141 12.625 0.431641 12.0625 0.431641 11.375Z",
    fill: "#0562D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.10161750dfdb78859b8dff23a30dcc5c.svg";
export { ForwardRef as ReactComponent };